var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import DateFnsUtils from "@date-io/date-fns";
import { format } from "date-fns";
var CSLocaleUtils = /** @class */ (function (_super) {
    __extends(CSLocaleUtils, _super);
    function CSLocaleUtils() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CSLocaleUtils.prototype.getMonthText = function (date) {
        return format(date, "LLLL", { locale: this.locale });
    };
    CSLocaleUtils.prototype.getCalendarHeaderText = function (date) {
        return format(date, "LLLL", { locale: this.locale });
    };
    CSLocaleUtils.prototype.getDatePickerHeaderText = function (date) {
        return format(date, "dd. LLLL", { locale: this.locale });
    };
    return CSLocaleUtils;
}(DateFnsUtils));
export { CSLocaleUtils };
export var formatDate = function (date) { return format(date, "yyyy-MM-dd"); };
